/* ============================================================
   FORGE — vanilla JS
   No deps. Event delegation. Idempotent — safe to re-run on
   Shopify section reload (theme editor).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.forge-faq__btn');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    var list = btn.closest('.forge-faq__list');
    // single-open behavior
    if (list && !open) {
      list.querySelectorAll('.forge-faq__btn[aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* ---------- Ingredient picker ----------
     One handler drives both presentations:
     - Mobile: toggles the clicked item's inline panel (single-open accordion)
     - Desktop: updates the side detail panel + .is-active highlight
     CSS decides which is visible at any breakpoint.
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.forge-ingredient');
    if (!btn) return;
    var section = btn.closest('[data-forge-ingredients]');
    if (!section) return;

    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    var allBtns = section.querySelectorAll('.forge-ingredient');

    // Accordion: collapse siblings, toggle self (but never fully collapse on desktop —
    // desktop always keeps one active; we re-open self if it was the only open one)
    allBtns.forEach(function (b) {
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (b === btn) {
        // On desktop the panel is display:none anyway; aria state still drives .is-active via JS below
        var willOpen = !isOpen;
        b.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (panel) panel.hidden = !willOpen;
      } else {
        b.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      }
    });

    // Desktop: ensure the clicked row is the active one even if it was "toggled closed"
    allBtns.forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    // guarantee clicked stays expanded for desktop side-panel logic
    btn.setAttribute('aria-expanded', 'true');
    var ownPanel = document.getElementById(btn.getAttribute('aria-controls'));
    // on mobile, honor the real toggle; re-hide if user intended to collapse
    if (isOpen && ownPanel && window.matchMedia('(max-width: 1099px)').matches) {
      btn.setAttribute('aria-expanded', 'false');
      ownPanel.hidden = true;
      btn.classList.remove('is-active');
    }

    // Update the desktop side panel from the button's own data-* attributes
    var detail = section.querySelector('[data-forge-ingredient-detail]');
    if (detail) {
      detail.querySelector('[data-tag]').textContent  = btn.getAttribute('data-tag')  || '';
      detail.querySelector('[data-name]').textContent = btn.getAttribute('data-name') || '';
      detail.querySelector('[data-amt]').textContent  = btn.getAttribute('data-amt')  || '';
      detail.querySelector('[data-copy]').textContent = btn.getAttribute('data-copy') || '';
    }
  });

  /* ---------- Variant selector (color / flavor / size buttons) ----------
     Clicking a [data-forge-variant] button:
     1. Updates aria-pressed within its group
     2. Looks up the matching variant in window.__forgeVariants__[productId]
        by reading all currently-selected values across [data-forge-variant-group]s
     3. Updates hidden name="id" input(s) on the page
     4. Updates the price display via [data-forge-variant-price]
     5. Dispatches forge:variant-change so the sticky bar can mirror
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-forge-variant]');
    if (!btn) return;
    var pid = btn.getAttribute('data-product-id');
    if (!pid || !window.__forgeVariants__ || !window.__forgeVariants__[pid]) return;
    var group = btn.closest('[data-forge-variant-group]');
    if (!group) return;

    // 1. mark this button active within its group
    group.querySelectorAll('[data-forge-variant]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });

    // 2. build the selected option array by reading every group on the page
    //    (lets multi-option products like flavor + size resolve correctly)
    var root = btn.closest('.forge-pdp, form, [data-forge-buybox]') || document;
    var selectedOptions = [];
    root.querySelectorAll('[data-forge-variant-group]').forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index') || '0', 10);
      var active = g.querySelector('[data-forge-variant][aria-pressed="true"]');
      if (active) selectedOptions[idx] = active.getAttribute('data-forge-variant');
    });

    var variants = window.__forgeVariants__[pid];
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (selectedOptions[j] && variants[i].options[j] !== selectedOptions[j]) { ok = false; break; }
      }
      if (ok) { match = variants[i]; break; }
    }
    if (!match) return;

    // 3. update every hidden name="id" on the page (main buybox + sticky)
    document.querySelectorAll('input[name="id"]').forEach(function (inp) {
      inp.value = match.id;
    });

    // 4. update variant price displays (only the ones tagged as variant-driven)
    var priceStr = match.priceFormatted;
    document.querySelectorAll('[data-forge-variant-price]').forEach(function (el) {
      el.textContent = priceStr;
    });

    // 5. broadcast for sticky bar
    document.dispatchEvent(new CustomEvent('forge:variant-change', {
      detail: {
        variantId: match.id,
        priceStr: priceStr,
        variantTitle: match.title,
        available: match.available
      }
    }));

    // 6. disable ATC if not available
    document.querySelectorAll('[data-forge-atc], button[type="submit"].forge-btn--primary').forEach(function (b) {
      if (b.closest('.forge-pdp__form, .forge-buybox-form, .forge-sticky-bar')) {
        b.disabled = !match.available;
        b.style.opacity = match.available ? '' : '0.5';
      }
    });
  });

  /* ---------- Plan toggle (subscribe vs one-time) ----------
     Uses data-forge-plan-toggle on container. Buttons carry
     data-plan="sub|one", data-price-id (selling plan id or
     blank for one-time), and data-price (formatted display).
     Updates: any [data-forge-price] in scope, hidden
     selling_plan input, ATC button label.
  ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-forge-plan]');
    if (!btn) return;
    var scope = btn.closest('[data-forge-plan-toggle]') || document;
    scope.querySelectorAll('[data-forge-plan]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var plan = btn.getAttribute('data-forge-plan');
    var price = btn.getAttribute('data-price') || '';
    var priceCompare = btn.getAttribute('data-price-compare') || '';
    var savePct = parseInt(btn.getAttribute('data-save-pct') || '0', 10);
    var planId = btn.getAttribute('data-plan-id') || '';
    var subText = btn.getAttribute('data-sub') || '';
    // root for updates (PDP form scope, or hero/buybox)
    var root = btn.closest('form') || btn.closest('[data-forge-buybox]') || document;
    var priceEl = root.querySelector('[data-forge-price]');
    if (priceEl) priceEl.textContent = price;
    var compareEl = root.querySelector('[data-forge-price-compare]');
    if (compareEl) {
      compareEl.textContent = priceCompare;
      compareEl.style.display = priceCompare ? '' : 'none';
    }
    var saveEl = root.querySelector('[data-forge-save]');
    if (saveEl) {
      if (savePct > 0) {
        saveEl.textContent = 'SAVE ' + savePct + '%';
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }
    var subEl = root.querySelector('[data-forge-sub]');
    if (subEl) subEl.textContent = subText;
    var planInput = root.querySelector('input[name="selling_plan"]');
    if (planInput) planInput.value = planId;
    var idInput = root.querySelector('input[name="id"]');
    var variantId = idInput ? idInput.value : '';
    // Mirror to other buyboxes on the page (e.g., desktop hero <-> mobile buybox)
    document.querySelectorAll('[data-forge-plan="' + plan + '"]').forEach(function (b) {
      if (b !== btn) b.setAttribute('aria-pressed', 'true');
    });
    document.querySelectorAll('[data-forge-plan]').forEach(function (b) {
      if (b.getAttribute('data-forge-plan') !== plan) b.setAttribute('aria-pressed', 'false');
    });

    // Broadcast for sticky bar + any other listeners
    document.dispatchEvent(new CustomEvent('forge:variant-change', {
      detail: {
        variantId: variantId,
        planId: planId,
        priceStr: price,
        priceCompareStr: priceCompare,
        savePct: savePct,
        metaStr: plan === 'sub' ? 'SUBSCRIBE & SAVE' : 'ONE-TIME'
      }
    }));
  });

  /* ---------- Sticky ATC bar ---------- */
  var sticky = document.querySelector('[data-forge-sticky]');
  if (sticky) {
    var threshold = parseInt(sticky.getAttribute('data-threshold') || '700', 10);
    var mainBuybox = document.querySelector('.forge-pdp__buybox, .forge-buybox') ;
    var footer = document.querySelector('.footer-sections') || document.querySelector('footer');
    var footerInView = false;
    var buyboxInView = false;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset;
      var show = y > threshold && !footerInView && !buyboxInView;
      sticky.classList.toggle('is-visible', show);
    }

    // Footer hide via IntersectionObserver — kills sticky when footer enters viewport
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        footerInView = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(footer);
    }

    // Hide sticky when the main buybox is on-screen (don't double-up)
    if (mainBuybox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyboxInView = entries[0].isIntersecting;
        update();
      }, { threshold: 0.2 }).observe(mainBuybox);
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();

    /* Variant + plan sync from main buybox -> sticky bar.
       The buybox dispatches `forge:variant-change` events; we listen
       and mirror price, variant id, plan id, and the meta line. */
    var stickyVid   = sticky.querySelector('[data-forge-sticky-vid]');
    var stickyPlan  = sticky.querySelector('[data-forge-sticky-plan]');
    var stickyPrice = sticky.querySelector('[data-forge-sticky-price]');
    var stickyMeta  = sticky.querySelector('[data-forge-sticky-meta]');

    document.addEventListener('forge:variant-change', function (e) {
      var d = e.detail || {};
      if (stickyVid && d.variantId)   stickyVid.value = d.variantId;
      if (stickyPlan)                  stickyPlan.value = d.planId || '';
      if (stickyPrice && d.priceStr)   stickyPrice.textContent = d.priceStr;
      if (stickyMeta && d.metaStr)     stickyMeta.textContent = d.metaStr;
    });
  }

  /* ---------- PDP gallery: slider, dots, thumbs ---------- */
  document.querySelectorAll('[data-forge-gallery]').forEach(function (gallery) {
    var slider = gallery.querySelector('[data-forge-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('.forge-pdp__slide');
    var dots = gallery.querySelectorAll('.forge-pdp__dot');
    var thumbs = gallery.querySelectorAll('.forge-pdp__thumb');

    function setActive(idx) {
      dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-pressed', i === idx ? 'true' : 'false'); });
    }
    function scrollTo(idx) {
      var slide = slides[idx];
      if (!slide) return;
      slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    }

    [].concat([].slice.call(dots), [].slice.call(thumbs)).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-slide-target'), 10) || 0;
        scrollTo(idx);
        setActive(idx);
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0.6) {
            var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10) || 0;
            setActive(idx);
          }
        });
      }, { root: slider, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
  });

  /* ---------- PDP variant pickers ---------- */
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-forge-variant]');
    if (!v) return;
    var group = v.closest('[data-forge-variant-group]');
    if (!group) return;
    group.querySelectorAll('[data-forge-variant]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === v ? 'true' : 'false');
    });
    // resolve combined variant id by walking all groups in form
    var form = v.closest('form');
    if (!form) return;
    var picks = [];
    form.querySelectorAll('[data-forge-variant-group]').forEach(function (g) {
      var sel = g.querySelector('[data-forge-variant][aria-pressed="true"]');
      if (sel) picks.push(sel.getAttribute('data-forge-variant'));
    });
    var key = picks.join(' / ');
    var variants = window.__forgeVariants__ && window.__forgeVariants__[form.getAttribute('data-product-id')];
    if (!variants) return;
    var match = variants.find(function (vv) { return vv.title === key || vv.options.join(' / ') === key; });
    var idInput = form.querySelector('input[name="id"]');
    if (match && idInput) {
      idInput.value = match.id;
      var priceEl = form.querySelector('[data-forge-variant-price]');
      if (priceEl) priceEl.textContent = match.priceFormatted;
      // toggle availability
      form.querySelector('[data-forge-atc]')?.toggleAttribute('disabled', !match.available);
      var soldOut = form.querySelector('[data-forge-soldout]');
      if (soldOut) soldOut.style.display = match.available ? 'none' : '';
    }
  });

  /* ---------- Quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-forge-qty]');
    if (!btn) return;
    var dir = btn.getAttribute('data-forge-qty');
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = dir === 'inc' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

})();

/* ============================================================
   FORGE — chrome JS additions
   Header scroll state, drawer open/close, AJAX cart add,
   cart line updates, mobile menu.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('[data-forge-header]');
  if (header) {
    var hTicking = false;
    function hUpdate() {
      hTicking = false;
      header.classList.toggle('is-scrolled', window.pageYOffset > 8);
    }
    window.addEventListener('scroll', function () {
      if (!hTicking) { window.requestAnimationFrame(hUpdate); hTicking = true; }
    }, { passive: true });
    hUpdate();
  }

  /* ---------- Drawer open/close ---------- */
  function openDrawer(target) {
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return;
    el.classList.add('is-open');
    var overlayId = el.getAttribute('data-overlay');
    if (overlayId) {
      var overlay = document.getElementById(overlayId);
      if (overlay) overlay.classList.add('is-open');
    }
    document.body.classList.add('forge-no-scroll');
    el.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer(target) {
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return;
    el.classList.remove('is-open');
    var overlayId = el.getAttribute('data-overlay');
    if (overlayId) {
      var overlay = document.getElementById(overlayId);
      if (overlay) overlay.classList.remove('is-open');
    }
    el.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.forge-drawer.is-open')) {
      document.body.classList.remove('forge-no-scroll');
    }
  }
  window.forgeOpenDrawer = openDrawer;
  window.forgeCloseDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-forge-open]');
    if (open) {
      e.preventDefault();
      openDrawer(open.getAttribute('data-forge-open'));
      return;
    }
    var close = e.target.closest('[data-forge-close]');
    if (close) {
      // If the close trigger is an <a> with an href, let the navigation
      // proceed. Otherwise prevent default (button / div / etc).
      var isNavLink = close.tagName === 'A' && close.getAttribute('href');
      if (!isNavLink) e.preventDefault();
      closeDrawer(close.getAttribute('data-forge-close'));
      return;
    }
    // Click an overlay to close all drawers
    if (e.target.classList && e.target.classList.contains('forge-overlay')) {
      document.querySelectorAll('.forge-drawer.is-open').forEach(function (d) { closeDrawer(d); });
    }
  });

  // ESC closes any open drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.forge-drawer.is-open').forEach(function (d) { closeDrawer(d); });
    }
  });

  /* ---------- Compare: mobile competitor toggle ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fc-toggle]');
    if (!btn) return;
    var section = btn.closest('[data-forge-compare]');
    if (!section) return;
    var col = btn.getAttribute('data-fc-toggle');
    section.querySelectorAll('[data-fc-toggle]').forEach(function (b) {
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
    var grid = section.querySelector('.forge-compare__grid');
    if (grid) grid.setAttribute('data-fc-active', col);
  });

  /* ---------- Judge.me preview badge -> smooth-scroll to reviews ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.forge-pdp__rating-jdgm');
    if (!t) return;
    var target = document.querySelector('.forge-reviews--judgeme_product .jdgm-review-widget')
              || document.querySelector('.jdgm-review-widget')
              || document.querySelector('.forge-reviews--judgeme_product');
    if (!target) return;
    e.preventDefault();
    var rect = target.getBoundingClientRect();
    var headerOffset = 80;
    window.scrollTo({
      top: window.pageYOffset + rect.top - headerOffset,
      behavior: 'smooth'
    });
  });

  /* ---------- AJAX cart add (intercept all forge ATC forms) ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.forge-pdp__form, .forge-buybox-form')) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[data-forge-atc]');
    var originalText;
    if (btn) {
      originalText = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.innerHTML = '<span>ADDING…</span>';
    }
    var fd = new FormData(form);
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.body && (res.body.description || res.body.message) || 'Add failed';
          console.error('[forge] /cart/add.js error:', res.body);
          throw new Error(msg);
        }
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          btn.innerHTML = '<span>ADDED ✓</span><span></span>';
        }
        // Open drawer immediately (don't wait on refresh) — refresh continues in parallel
        var drawer = document.getElementById('forge-cart-drawer');
        if (drawer) openDrawer(drawer);
        // Bump cart count badge for visual feedback even before refresh resolves
        document.querySelectorAll('[data-forge-cart-count]').forEach(function (el) {
          el.classList.remove('is-bumping');
          // force reflow so re-adding class re-runs animation
          void el.offsetWidth;
          el.classList.add('is-bumping');
        });
        return refreshCart();
      })
      .catch(function (err) {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          btn.innerHTML = '<span>ERROR — ' + (err.message || 'TRY AGAIN').toUpperCase() + '</span><span></span>';
        }
        console.error('[forge] add to cart failed:', err);
      })
      .finally(function () {
        setTimeout(function () {
          if (btn && originalText) {
            btn.disabled = false;
            btn.classList.remove('is-loading', 'is-success', 'is-error');
            btn.innerHTML = originalText;
          }
        }, 700);
      });
  }, true);

  /* ---------- Refresh cart drawer + count ---------- */
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var v = cents / 100;
    function thousand(numStr, sep) {
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }
    var subs = {
      'amount':                                    thousand(v.toFixed(2), ','),
      'amount_no_decimals':                        thousand(Math.round(v).toString(), ','),
      'amount_with_comma_separator':               thousand(v.toFixed(2), '.').replace(/\.(\d{2})$/, ',$1'),
      'amount_no_decimals_with_comma_separator':   thousand(Math.round(v).toString(), '.'),
      'amount_with_apostrophe_separator':          thousand(v.toFixed(2), "'"),
      'amount_no_decimals_with_space_separator':   thousand(Math.round(v).toString(), ' '),
      'amount_with_space_separator':               thousand(v.toFixed(2), ' '),
      'amount_with_period_and_space_separator':    thousand(v.toFixed(2), ' ').replace(/\.(\d{2})$/, '.$1')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, key) {
      return key in subs ? subs[key] : '';
    });
  }

  function refreshCart() {
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Count badge
        document.querySelectorAll('[data-forge-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        // Drawer body re-render
        var drawerBody = document.querySelector('[data-forge-cart-body]');
        var drawerFoot = document.querySelector('[data-forge-cart-foot]');
        var drawerHead = document.querySelector('[data-forge-cart-head]');
        if (drawerBody) drawerBody.innerHTML = renderCartBody(cart);
        if (drawerFoot) drawerFoot.innerHTML = renderCartFoot(cart);
        if (drawerHead) drawerHead.innerHTML = renderCartHead(cart);
        return cart;
      });
  }
  window.forgeRefreshCart = refreshCart;

  // Map JS keys to data-i18n-* attribute names on #forge-cart-drawer.
  // The drawer snippet renders translations into these attributes at request
  // time, so the language always matches the server-rendered locale even if
  // window.forgeI18n is missing.
  var FORGE_I18N_ATTR_MAP = {
    title:        'i18nTitle',
    itemSingular: 'i18nItemSingular',
    itemPlural:   'i18nItemPlural',
    subtotal:     'i18nSubtotal',
    checkout:     'i18nCheckout',
    emptyTitle:   'i18nEmptyTitle',
    emptyMeta:    'i18nEmptyMeta',
    shipNote:     'i18nShipNote',
    remove:       'i18nRemove',
    decrease:     'i18nDecrease',
    increase:     'i18nIncrease',
    close:        'i18nClose'
  };
  function forgeI18nCart(key, fallback) {
    // Priority 1: drawer dataset (server-rendered, always current locale)
    try {
      var drawer = document.getElementById('forge-cart-drawer');
      if (drawer) {
        var attr = FORGE_I18N_ATTR_MAP[key];
        if (attr) {
          var v = drawer.dataset[attr];
          if (v != null && v !== '') return v;
        }
      }
    } catch (e) {}
    // Priority 2: global forgeI18n (legacy, kept for any other consumers)
    try {
      var w = window.forgeI18n && window.forgeI18n.cart && window.forgeI18n.cart[key];
      if (w != null && w !== '') return w;
    } catch (e) {}
    return fallback || '';
  }
  function forgeCountLabel(n) {
    var template = (n === 1)
      ? forgeI18nCart('itemSingular', '{{ count }} item')
      : forgeI18nCart('itemPlural', '{{ count }} items');
    return template.replace(/\{\{\s*count\s*\}\}/g, n);
  }
  // Robust check for synthetic "Default Title" variant values that Shopify
  // creates on variant-less products. Matches case-insensitively and tolerates
  // any whitespace variation.
  var FORGE_DEFAULT_TITLE_RE = /^\s*default\s*title\s*$/i;
  function forgeIsRealOption(o) {
    return o && o.value && !FORGE_DEFAULT_TITLE_RE.test(o.value);
  }

  function renderCartHead(cart) {
    var n = cart.item_count;
    return ''
      + '<div>'
      + '<span class="forge-mono" style="font-size:10px;letter-spacing:0.18em;color:var(--f-red);text-transform:uppercase;">'
      + escapeHtml(forgeI18nCart('title', 'Your cart').toUpperCase())
      + '</span>'
      + '<div class="forge-display" style="font-size:24px;margin-top:4px;">'
      + escapeHtml(forgeCountLabel(n))
      + '</div>'
      + '</div>'
      + '<button type="button" class="forge-drawer__close" data-forge-close="#forge-cart-drawer" aria-label="'
      + escapeHtml(forgeI18nCart('close', 'Close')) + '">\u00D7</button>';
  }

  var TRASH_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M6 6l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';

  function renderCartBody(cart) {
    if (!cart.items || cart.items.length === 0) {
      return ''
        + '<div class="forge-cart-drawer__empty">'
        + '<div class="forge-cart-drawer__empty-title">' + escapeHtml(forgeI18nCart('emptyTitle', 'Empty.')) + '</div>'
        + '<span class="forge-cart-drawer__empty-meta">' + escapeHtml(forgeI18nCart('emptyMeta', 'Add something.').toUpperCase()) + '</span>'
        + '</div>';
    }
    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2') + '" alt="" loading="lazy">'
        : '';
      // Filter out the synthetic "Default Title" option Shopify auto-creates
      // for variant-less products. Robust to whitespace and case variants.
      var realOpts = (item.options_with_values || []).filter(forgeIsRealOption);
      var optsRaw = realOpts.length > 0
        ? realOpts.map(function (o) { return o.value; }).join(' \u00B7 ').toUpperCase()
        : '';
      var isSub = !!item.selling_plan_allocation;
      var planName = isSub && item.selling_plan_allocation.selling_plan
        ? (item.selling_plan_allocation.selling_plan.name || '').toUpperCase()
        : '';
      var subTag = isSub
        ? '<span class="forge-cart-drawer__line-sub-tag">\u21BB ' + planName + '</span>'
        : '';
      var sep = isSub && optsRaw ? ' \u00B7 ' : '';
      var metaText = subTag + sep + optsRaw;
      var strike = (item.original_line_price > item.final_line_price)
        ? '<span class="forge-cart-drawer__line-strike">' + formatMoney(item.original_line_price) + '</span>'
        : '';
      var removeLabel = escapeHtml(forgeI18nCart('remove', 'Remove'));
      var decreaseLabel = escapeHtml(forgeI18nCart('decrease', 'Decrease'));
      var increaseLabel = escapeHtml(forgeI18nCart('increase', 'Increase'));
      var decBtn = item.quantity === 1
        ? '<button type="button" data-forge-line-qty="dec" data-key="' + item.key + '" aria-label="' + removeLabel + '">' + TRASH_SVG + '</button>'
        : '<button type="button" data-forge-line-qty="dec" data-key="' + item.key + '" aria-label="' + decreaseLabel + '">\u2212</button>';
      // Defensive title fallback (matches the liquid path)
      var title = item.product_title || item.title || '';
      html += ''
        + '<div class="forge-cart-drawer__line' + (isSub ? ' is-subscription' : '') + '" data-line-key="' + item.key + '">'
        + '<a href="' + item.url + '" class="forge-cart-drawer__line-img" data-forge-close="#forge-cart-drawer">' + img + '</a>'
        + '<div class="forge-cart-drawer__line-info">'
        + '<a href="' + item.url + '" class="forge-cart-drawer__line-title" data-forge-close="#forge-cart-drawer">' + escapeHtml(title) + '</a>'
        + '<span class="forge-cart-drawer__line-meta">' + metaText + '</span>'
        + '<div class="forge-cart-drawer__line-foot">'
        + '<div class="forge-cart-drawer__qty">'
        + decBtn
        + '<input type="number" value="' + item.quantity + '" min="0" data-key="' + item.key + '">'
        + '<button type="button" data-forge-line-qty="inc" data-key="' + item.key + '" aria-label="' + increaseLabel + '">+</button>'
        + '</div>'
        + '<div class="forge-cart-drawer__line-price">' + formatMoney(item.final_line_price) + strike + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';
    });
    return html;
  }

  function renderCartFoot(cart) {
    if (!cart.items || cart.items.length === 0) {
      return '<button type="button" class="forge-btn forge-btn--ghost forge-btn--full" data-forge-close="#forge-cart-drawer">' + escapeHtml(forgeI18nCart('close', 'Close').toUpperCase()) + '</button>';
    }
    var checkoutLabel = escapeHtml(forgeI18nCart('checkout', 'Secure checkout').toUpperCase());
    var subtotalLabel = escapeHtml(forgeI18nCart('subtotal', 'Subtotal').toUpperCase());
    var shipNote = forgeI18nCart('shipNote', '');
    var shipNoteEl = shipNote
      ? '<span class="forge-cart-drawer__shipnote">' + escapeHtml(shipNote) + '</span>'
      : '';
    return ''
      + '<div class="forge-cart-drawer__totals">'
      + '<span class="forge-cart-drawer__totals-label">' + subtotalLabel + '</span>'
      + '<span class="forge-cart-drawer__totals-amount">' + formatMoney(cart.total_price) + '</span>'
      + '</div>'
      + '<a href="/checkout" class="forge-btn forge-btn--primary forge-btn--lg forge-btn--full forge-btn--split">'
      + '<span>' + checkoutLabel + '</span><span>\u2192</span></a>'
      + shipNoteEl;
  }

  // Minimal HTML escape for values we inject as text content.
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ---------- Cart line item update / remove ----------
     Debounced + serialized so rapid +/- clicks collapse into ONE
     network request carrying the final quantity. Optimistic UI keeps
     the number responsive; the server is synced once per settled change.
  ---------------------------------------------------------- */
  var pendingQty = {};            // key -> desired quantity (latest intent)
  var qtyTimers  = {};            // key -> debounce timer
  var cartBusy   = false;         // true while a change.js request is in flight
  var cartQueued = false;         // true if another flush was requested mid-flight
  var QTY_DEBOUNCE = 350;

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-forge-line-qty]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var input = qtyBtn.parentElement.querySelector('input[data-key]');
      // base off the latest pending intent if we have one, else the input
      var current = (key in pendingQty)
        ? pendingQty[key]
        : (parseInt(input && input.value, 10) || 1);
      var next = qtyBtn.getAttribute('data-forge-line-qty') === 'inc'
        ? current + 1
        : Math.max(0, current - 1);
      if (next === 0) {
        // removal — apply immediately, skip debounce
        if (qtyTimers[key]) { clearTimeout(qtyTimers[key]); delete qtyTimers[key]; }
        pendingQty[key] = 0;
        flushCartChanges();
      } else {
        queueLineChange(key, next, input);
      }
      return;
    }
    var rmBtn = e.target.closest('[data-forge-line-remove]');
    if (rmBtn) {
      // removal is explicit — apply immediately, no debounce
      var rmKey = rmBtn.getAttribute('data-key');
      delete pendingQty[rmKey];
      if (qtyTimers[rmKey]) { clearTimeout(qtyTimers[rmKey]); delete qtyTimers[rmKey]; }
      pendingQty[rmKey] = 0;
      flushCartChanges();
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-key]');
    if (!input) return;
    var key = input.getAttribute('data-key');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    queueLineChange(key, qty, input);
  });

  // Record intent, update the visible number now, debounce the request.
  function queueLineChange(key, qty, input) {
    pendingQty[key] = qty;
    if (input) input.value = qty;       // optimistic: number reacts instantly
    if (qtyTimers[key]) clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      delete qtyTimers[key];
      flushCartChanges();
    }, QTY_DEBOUNCE);
  }

  // Send all settled line changes. Serialized: if a request is already
  // in flight, mark queued and re-flush when it resolves — so we always
  // converge on the latest intent and never race change.js calls.
  function flushCartChanges() {
    if (cartBusy) { cartQueued = true; return; }
    var keys = Object.keys(pendingQty);
    if (keys.length === 0) return;
    // don't send keys still waiting on their debounce timer
    var ready = keys.filter(function (k) { return !qtyTimers[k]; });
    if (ready.length === 0) return;

    cartBusy = true;
    // change.js handles one line per call; chain ready lines sequentially.
    var chain = Promise.resolve();
    ready.forEach(function (key) {
      var qty = pendingQty[key];
      delete pendingQty[key];
      chain = chain.then(function () {
        return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root : '/') + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); }).catch(function (err) {
          console.error('[forge] cart/change.js failed:', err);
        });
      });
    });

    chain
      .then(function () { return refreshCart(); })
      .catch(function (err) { console.error('[forge] cart refresh failed:', err); })
      .finally(function () {
        cartBusy = false;
        // anything queued or newly-settled while we were busy? flush again.
        if (cartQueued || Object.keys(pendingQty).some(function (k) { return !qtyTimers[k]; })) {
          cartQueued = false;
          flushCartChanges();
        }
      });
  }

  /* ---------- Mobile menu disclosure groups ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-forge-mm-toggle]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-forge-mm-toggle'));
    if (target) target.toggleAttribute('hidden');
  });

  /* ---------- Judge.me star replacement ----------
     Judge.me's stars render via webfont/SVG masks that can fail to load,
     leaving broken crown/diamond glyphs. This finds their star containers,
     reads the score, and rewrites them with real Unicode star markup.
     Hooked to DOM ready + Judge.me lifecycle events + MutationObserver
     for lazy-loaded reviews and infinite-scroll pagination.
  ---------------------------------------------------------- */
  var FORGE_JM_SELECTORS = [
    '.jdgm-prev-badge__stars',
    '.jdgm-rev__rating',
    '.jdgm-rev-widg__summary-stars',
    '.jdgm-carousel-item__rating',
    '.jm-star-rating',
    '.jm-review-rating'
  ].join(',');

  function forgeReadJmScore(container) {
    // 1. aria-label — every Judge.me jm-star-rating container carries
    //    `aria-label="N out of 5 stars"`. This is the most reliable source.
    var aria = container.getAttribute && container.getAttribute('aria-label');
    if (aria) {
      var m = aria.match(/(\d+(?:\.\d+)?)\s*(?:out of|\/)\s*5/i);
      if (m) {
        var an = parseFloat(m[1]);
        if (!isNaN(an)) return Math.max(0, Math.min(5, an));
      }
    }
    // 2. Walk container + up to 4 ancestors for explicit rating attrs.
    var el = container;
    var attrs = [
      'data-score',
      'data-average-rating',
      'data-rating',
      'data-value',
      'data-aggregate-rating'
    ];
    for (var depth = 0; el && depth < 5; depth++) {
      for (var i = 0; i < attrs.length; i++) {
        var v = el.getAttribute && el.getAttribute(attrs[i]);
        if (v != null && v !== '') {
          var n = parseFloat(v);
          if (!isNaN(n) && n >= 0 && n <= 5) return n;
        }
      }
      el = el.parentElement;
    }
    // 3. Count filled/half star children. Covers Judge.me's actual classes
    //    (jm-star-rating__filled, jm-star-rating__half) plus legacy variants.
    var full = container.querySelectorAll(
      '.jm-star-rating__filled, .jdgm--on, .jdgm-star--on,'
      + '[class*="__filled"], [class*="__full"],'
      + '[class*="--filled"], [class*="--full"], [class*="--on"]'
    ).length;
    var half = container.querySelectorAll(
      '.jm-star-rating__half, .jdgm--half, .jdgm-star--half,'
      + '[class*="__half"], [class*="--half"]'
    ).length;
    if (full || half) return Math.max(0, Math.min(5, full + half * 0.5));

    return null; // unknown -> leave original intact
  }

  function forgeReplaceJmStars(root) {
    (root || document).querySelectorAll(FORGE_JM_SELECTORS).forEach(function (container) {
      if (container.hasAttribute('data-forge-stars')) return;
      var score = forgeReadJmScore(container);
      if (score == null) return;
      var pct = (score / 5) * 100;
      container.innerHTML =
        '<span class="forge-stars__track" aria-hidden="true">'
        +   '<span class="forge-stars__empty">\u2605\u2605\u2605\u2605\u2605</span>'
        +   '<span class="forge-stars__fill" style="width:' + pct + '%">\u2605\u2605\u2605\u2605\u2605</span>'
        + '</span>';
      container.setAttribute('data-forge-stars', score.toFixed(1));
      container.setAttribute('role', 'img');
      container.setAttribute('aria-label', score + ' out of 5 stars');
    });
  }

  // Run on ready, and again after Judge.me's typical lifecycle events
  function forgeKickJmStars() { forgeReplaceJmStars(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forgeKickJmStars);
  } else {
    forgeKickJmStars();
  }
  ['load', 'jdgm.loaded', 'jm-review-widget:loaded', 'jdgm_reviews_loaded']
    .forEach(function (evt) { window.addEventListener(evt, forgeKickJmStars); });

  // Catch lazy-loaded reviews (pagination, infinite scroll, filter changes,
  // Vue progressive mount). Process EVERY matching addition in every batch.
  if ('MutationObserver' in window) {
    var pendingRun = false;
    function scheduleRun() {
      if (pendingRun) return;
      pendingRun = true;
      // Coalesce many adjacent mutations into one pass on the next frame.
      (window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); })(function () {
        pendingRun = false;
        forgeReplaceJmStars();
      });
    }
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          // Match either: the node IS a star rating, the node CONTAINS one,
          // or the node is INSIDE one (e.g. Vue mounting child SVGs late).
          if (
            (n.matches && n.matches(FORGE_JM_SELECTORS)) ||
            (n.querySelector && n.querySelector(FORGE_JM_SELECTORS)) ||
            (n.closest && n.closest(FORGE_JM_SELECTORS))
          ) {
            scheduleRun();
            break; // one schedule covers the whole batch
          }
        }
      }
    });
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

})();
